import { RootState } from '@/store/store';
import { ResultState } from '@/store/types/resultTypes';
import { createSelector } from '@reduxjs/toolkit';

export const selectResult = (state: RootState): ResultState => state.result as ResultState;

export const selectTestId = createSelector(
	[
		(state: RootState) => state.result.resultData?.test?.id,
		(state: RootState) => state.testing.testId,
	],
	// Приоритет: результат теста → тест-процесс (Islands на стартовой странице)
	(resultTestId, testingTestId) => resultTestId ?? testingTestId ?? null
);
